import React from "react";

const EventsSelectionCard = ({
  events,
  selectedEvent,
  onEventSelect,
  getEventSignupStatus,
  pageHeader = null,
  error = null,
}) => {
  return (
    <div className="card-board overflow-hidden mb-8">
      {pageHeader}
      <div className="p-4 sm:p-6">
        <div className="grid gap-4">
          {events.map((event) => {
            const signupStatus = getEventSignupStatus(event) || {};
            const isSelected = selectedEvent?.id === event.id;
            const isViaDoubles = Boolean(signupStatus.viaDoubles);
            const isDisabled = !signupStatus.selectable;
            const note = signupStatus.note || null;
            const bowlerCount = event.bowlerQuantity || 1;
            const entryFeePerBowler = event.entryFee || 0;
            const totalCost = entryFeePerBowler * bowlerCount;
            const mutedClass = isSelected
              ? "text-brand-mist"
              : isViaDoubles
                ? "text-brand-muted"
                : isDisabled
                  ? "text-gray-400"
                  : "text-brand-muted";

            return (
              <div
                key={event.id}
                className={`relative p-4 rounded-lg transition-all duration-200 ${
                  isSelected
                    ? "bg-brand-charcoal text-brand-cream shadow-sm cursor-pointer"
                    : isViaDoubles
                    ? "bg-white border border-gray-200"
                    : isDisabled
                    ? "bg-brand-cream text-gray-400 cursor-not-allowed border border-gray-200"
                    : "bg-white border border-gray-200 hover:border-brand-charcoal/20 hover:shadow-md cursor-pointer"
                }`}
                onClick={() => !isDisabled && onEventSelect(event)}
              >
                <div className="min-w-0">
                  <div className="flex items-start justify-between gap-3">
                    <h3
                      className={`text-lg font-semibold mb-2 min-w-0 ${
                        isSelected
                          ? "text-white"
                          : isDisabled && !isViaDoubles
                            ? "text-gray-400"
                            : "text-gray-900"
                      }`}
                    >
                      {event.eventName}
                    </h3>
                    {isSelected ? (
                      <div className="flex items-center justify-center w-6 h-6 shrink-0 bg-white bg-opacity-20 rounded-full">
                        <svg
                          className="w-3 h-3 text-white"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    ) : null}
                  </div>
                  {note ? (
                    <p className={`text-sm mb-2 ${mutedClass}`}>{note}</p>
                  ) : null}

                  <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-6">
                    <div className={`text-sm ${mutedClass}`}>
                      {bowlerCount} {bowlerCount === 1 ? "Bowler" : "Bowlers"}
                    </div>

                    <div className={`text-sm ${mutedClass}`}>
                      ${entryFeePerBowler} per bowler
                    </div>

                    <div
                      className={`text-lg font-bold ${
                        isSelected
                          ? "text-white"
                          : isDisabled && !isViaDoubles
                            ? "text-gray-400"
                            : "text-brand-gold-ink"
                      }`}
                    >
                      Total: ${totalCost}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {error ? (
          <p data-signup-error="" className="mt-4 text-sm text-red-600">
            {error}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default EventsSelectionCard;
